import { render, staticRenderFns } from "./newDevice.vue?vue&type=template&id=367a6c7b&scoped=true&"
import script from "./newDevice.vue?vue&type=script&lang=js&"
export * from "./newDevice.vue?vue&type=script&lang=js&"
import style0 from "./newDevice.vue?vue&type=style&index=0&id=367a6c7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a6c7b",
  null
  
)

export default component.exports